import { Box, Tooltip } from '@mui/material';
import { Label as MetadataIcon } from '@mui/icons-material';
import { StyledChip } from './SharedStyles';
import { RecordStringMetadataFilterValue } from '@/api/generatedApi';

export const MetadataFiltersDetail = ({ metadataFilters }: { metadataFilters?: RecordStringMetadataFilterValue }) => {
  if (!metadataFilters) return;
  const metadataCount = Object.keys(metadataFilters).length;

  return (
    <Tooltip
      title={
        <Box>
          {Object.entries(metadataFilters).map(([key, value]) => (
            <Box key={key} sx={{ fontSize: '0.75rem', mb: 0.5 }}>
              <strong>{key}:</strong> {Array.isArray(value) ? value.join(', ') : String(value)}
            </Box>
          ))}
        </Box>
      }
    >
      <StyledChip
        icon={<MetadataIcon />}
        label={`${metadataCount} filter${metadataCount > 1 ? 's' : ''}`}
        size='small'
        color='secondary'
      />
    </Tooltip>
  );
};
